import Helper from './Helper';

class Accordion {
  constructor(config = {}) {
    const { accordions } = config;

    this.accordions = Array.from(document.querySelectorAll(accordions));
    if (!this.accordions.length) return;

    // Disable browser auto scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    this.bindEvents();
    this.handleHashOnLoad();
  }

  handleHashOnLoad() {
    const hash = window.location.hash;
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    const headerEl = document.querySelector('.header');
    const headerHeight = headerEl ? headerEl.offsetHeight : 0;

    const accordionHeader = target.querySelector('.ns-accordion__head');
    if (!accordionHeader) return;

    window.scrollTo(0, 0);
    accordionHeader.click();

    setTimeout(() => {
      const rect = accordionHeader.getBoundingClientRect();
      const absoluteTop = rect.top + window.pageYOffset;
      const finalPosition = absoluteTop - headerHeight;

      window.scrollTo({
        top: finalPosition,
        behavior: 'smooth'
      });
    }, 350);
  }

  bindEvents() {
    this.accordions.forEach(el => {
      el.addEventListener('click', () => {
        const content = el.nextElementSibling;
        if (!content) return;

        if (el.classList.contains('active')) {
          Helper.slideClose(content);
          el.classList.remove('active');
          content.classList.remove('active');
        } else {
          el.classList.add('active');
          Helper.slideOpen(content, true);
          content.classList.add('active');
        }
      });
    });
  }
}

export default Accordion;
